import PreliminaryLifecarePlan from '../../../components/preliminary-lifecare/PreliminaryLifecarePlan';

const PreliminaryLifecarePlanPage = () => {
    return <PreliminaryLifecarePlan />;
};

export default PreliminaryLifecarePlanPage;
